import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DragDropService } from '../../../services/builder/drag-drop.service';
import { WidgetService } from '../../../services/builder/widget.service';
import { RadioButtonCPanelComponent } from './customizationPanel';

export interface SelectOption {
  label: string;
  value: string | number;
  valueEqualsDescription: boolean;
  type: 'string' | 'number';
  weight: number;
}

export interface RadioButtonCustomization {
  defaultValue: string | number;
  options: SelectOption[];
  showIfRule: string;
  autocompleteRule: boolean;
  required: boolean;
}

@Component({
  selector: 'lib-radiobutton-edit',
  imports: [RadioButtonModule, RadioButtonCPanelComponent, FormsModule],
  template: `
    <!-- CONFIGURATION PANEL -->
    @if (widgetService.settingVisibility()) {
      <lib-radiobutton-custom-panel />
    }

    <!-- OBJECT RAPRESENTATION -->
    @let widget = widgetService.widget();
    @if (widget) {
      <div class="relative flex h-full flex-col gap-2">
        @if (!widgetService.baseElementShowDescription()) {
          <div class="flex flex-row items-center gap-2">
            {{ widgetService.computedDescription() }}
          </div>
        }
        <div [class]="'p-fluid flex flex-wrap' + topologyStyle">
          @for (
            option of widget.customization.options;
            track option.value;
            let i = $index
          ) {
            <div class="flex flex-row items-center gap-2">
              <p-radioButton
                [autofocus]="false"
                [value]="option.value"
                [ngModel]="widget.customization.defaultValue"
                [disabled]="true"
                inputId="{{ widgetService.uniqueId }}-{{ i }}"
              ></p-radioButton>
              <label for="{{ widgetService.uniqueId }}-{{ i }}">
                {{ option.label }}
                ({{ widgetService.getWeightedPoints(option.weight)() }} pt)
              </label>
            </div>
          }
        </div>
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class RadioButtonComponent {
  public dragDropService = inject(DragDropService);
  protected widgetService = inject(WidgetService<RadioButtonCustomization>);

  protected topologyStyle = ' flex-row gap-5';
}
